import { RequireAccess } from '@/components'
import { useJobillaOrgId } from '@/hooks'
import { t } from 'i18next'
import { SettingsNav } from '../settings-nav'
import { SettingsSubheading } from '../shared'
import { CustomFieldSection } from './custom-fields/CustomFieldSection'

export function CustomFields() {
	const organisationId = useJobillaOrgId()

	return (
		<SettingsNav active="custom-fields" fullWidth={false}>
			<section className="space-y-8 mt-8 pr-8 max-w-[800px]">
				<SettingsSubheading>{t('settings.customFields.title')}</SettingsSubheading>

				<RequireAccess
					permission="custom-fields:read"
					fallback={
						<div className="text-sm text-gray-500">
							{t('settings.campaignSettings.noPermission')}
						</div>
					}
				>
					<CustomFieldSection organisationId={organisationId} />
				</RequireAccess>
			</section>
		</SettingsNav>
	)
}
